import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { TagStore } from 'src/app/shared/services/tag/state/tag.state';

export const tagResolver: ResolveFn<boolean> = () => {
  inject(TagStore).load();
  return true;
};
